export const LOADER_NAMESPACE = 'loader';
export const LOADER_GETTER = 'loaderGetter';
export const LOADER_START_MUTATION = 'loaderStartMutation';
export const LOADER_STOP_MUTATION = 'loaderStopMutation';
export const LOADER_START_ACTION = 'loaderStartAction';
export const LOADER_STOP_ACTION = 'loaderStopAction';

export default {
    namespaced: true,
    state: {
        loading: []
    },
    getters: {
        /**
         * Return true if the query is executed
         *
         * @param {Object} state - Vuex state
         *
         * @return {boolean}
         */
        [LOADER_GETTER]: state => index => !!state.loading.find(url => url === index)
    },
    actions: {
        /**
         * Start loading
         *
         * @param {Object} context
         * @param {string} index - Loading index
         *
         * @return {void}
         */
        [LOADER_START_ACTION](context, index) {
            context.commit(LOADER_START_MUTATION, index);
        },
        /**
         * Stop loading
         *
         * @param {Object} context
         * @param {string} index - Loading index
         *
         * @return {void}
         */
        [LOADER_STOP_ACTION](context, index) {
            context.commit(LOADER_STOP_MUTATION, index);
        }
    },
    mutations: {
        /**
         * Save query execution state
         *
         * @param {Object} state - Vuex state
         * @param {string} index - Query execution state
         *
         * @return {void}
         */
        [LOADER_START_MUTATION](state, index) {
            state.loading.push(index);
        },
        /**
         * Save query execution state
         *
         * @param {Object} state - Vuex state
         * @param {string} index - Query execution state
         *
         * @return {void}
         */
        [LOADER_STOP_MUTATION](state, index) {
            state.loading = state.loading.filter(url => url !== index);
        }
    }
};
